import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcAccount32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m21.5 16.5c3.719 0 6.5 2.906 6.5 7v5.5c0 .563-.438 1-1 1-.563 0-1-.438-1-1v-5.5c0-3.438-2.156-4.813-4.25-5-1.75.969-3.75 1.438-5.75 1.438s-4-.47-5.75-1.438c-2.094.188-4.25 1.563-4.25 5v5.5c0 .563-.438 1-1 1-.563 0-1-.438-1-1v-5.5c0-4.063 2.75-7.031 6.469-7 .219.002.375.031.531.125a9.711 9.711 0 0 0 5 1.375 9.711 9.711 0 0 0 5-1.375.917.917 0 0 1 .5-.125zm-5.5-14.5c3.875 0 7 3.156 7 7s-3.125 7-7 7-7-3.156-7-7 3.125-7 7-7zm0 2c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcAccount32;
